var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"btn",attrs:{"small":"","elevation":"0"},on:{"click":_vm.toggleTTSMode}},[_c('span',[_vm._v(_vm._s(_vm.ttsModeBtnText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }